<div [formGroup]="form()" class="address-row">
    <div class="form-field-container city">
        <app-city-input [control]="cityControl" [required]="cityRequired()"> </app-city-input>
    </div>
    <div class="form-field-container state">
        <app-state-input [control]="stateControl" [districtMode]="districtMode()" [required]="stateRequired()"> </app-state-input>
    </div>
    <div class="form-field-container zip">
        <app-zip-input [control]="zipControl" [districtMode]="districtMode()" [required]="zipRequired()"> </app-zip-input>
    </div>
</div>
